import { createFileRoute, redirect } from '@tanstack/react-router';
import { AccountIntegrationPage } from '@/pages/AccountIntegration';
import { isDevEnv } from '@/utils';

type Tab = 'overview' | 'create-invoice' | 'search-invoice' | 'reports';

const VALID_TABS: Tab[] = ['overview', 'create-invoice', 'search-invoice', 'reports'];

export const Route = createFileRoute('/_admin/account-integration')({
  beforeLoad: () => {
    if (!isDevEnv()) {
      throw redirect({
        to: '/order-management',
        search: { page: 1, limit: undefined, search: undefined, status: undefined, tab: undefined, view: undefined },
      });
    }
  },
  validateSearch: (search: Record<string, unknown>) => ({
    tab: (VALID_TABS.includes(search.tab as Tab) ? search.tab : 'overview') as Tab,
  }),
  component: AccountIntegrationPage,
});
